import PrevNextNavigation from "./prevNextNavigation";

export default PrevNextNavigation;
